module.exports = __webpack_public_path__ + "img/source05_1.70bfe926.png";